import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Footer.module.css";
import mondovivaLogo from "../../../assets/img/core-img/zorni-logo-footer.png";

/**
 * Pied de page.
 *
 * Il ne contient que des destinations qui existent : le gabarit d'origine
 * listait « About Us », « Our Room », « Career », un blog daté de 2019 et des
 * coordonnées de démonstration, tous en `href="#"`.
 *
 * Les colonnes « Mon compte » mènent à des pages protégées : un visiteur non
 * connecté passe par l'écran d'authentification, ce qui est le comportement
 * attendu.
 */
export function Footer() {
  const { t } = useTranslation();
  const location = useLocation();

  /* Le back-office et la page d'erreur ont leur propre mise en page. */
  if (
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/error")
  ) {
    return null;
  }

  const columns = [
    {
      id: "explore",
      title: t("footer.explore", "Explorer"),
      links: [
        { to: "/trips", label: t("footer.allTrips", "Tous les voyages") },
        { to: "/favorites", label: t("footer.favorites", "Mes favoris") },
      ],
    },
    {
      id: "account",
      title: t("footer.account", "Mon compte"),
      links: [
        { to: "/my-trips", label: t("components.myTrips.pageTitle", "Mes voyages") },
        { to: "/profil", label: t("profile.title", "Mon profil") },
      ],
    },
    {
      id: "help",
      title: t("footer.help", "Aide et informations"),
      links: [
        { to: "/faq", label: t("footer.faq", "Questions fréquentes") },
        { to: "/cgu", label: t("footer.cgu", "Conditions générales") },
        { to: "/mentions-legales", label: t("footer.legal", "Mentions légales") },
        { to: "/confidentialite", label: t("footer.privacy", "Confidentialité") },
      ],
    },
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <Link to="/" className={styles.brandLink}>
              <img src={mondovivaLogo} alt="Mondoviva" />
            </Link>
            <p className={styles.tagline}>
              {t(
                "footer.tagline",
                "Des voyages organisés, choisis un par un. Vous partez, on s'occupe du reste."
              )}
            </p>
          </div>

          {columns.map((column) => (
            <nav
              key={column.id}
              className={styles.column}
              aria-labelledby={`footer-${column.id}`}
            >
              <h2 className={styles.columnTitle} id={`footer-${column.id}`}>
                {column.title}
              </h2>
              <ul className={styles.links}>
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} Mondoviva ·{" "}
            {t("footer.rights", "Tous droits réservés")}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
